import React from 'react';
import { Card, Text } from '@commonsku/design-system';

export type TaskPreviewProps = {
    messageText: string;
    dueInDays: number;
};

export const TaskPreview = ({ messageText, dueInDays }: TaskPreviewProps) => {
    return (
        <Card.Root>
            <Card.Body gap="2.5" padding="4">
                <Text fontSize="md" margin="0!" fontWeight='semibold'>{messageText}</Text>
                <Text fontSize="sm" margin="0!" color='fg.muted'>Due: {dueInDays} days from task creation</Text>
            </Card.Body>
        </Card.Root>
    );
};
